module.exports = __webpack_public_path__ + "img/Gan.16804678.jpeg";